import styled from 'styled-components';
import { media } from 'common/responsive';


const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  overflow: hidden;
  min-height: 300px;
  flex-basis: 50%;
  
  ${media.tablet`
    min-height: 360px;
  `}
  ${media.desktop`
    min-height: 100%;
  `}
`;

export default ImageWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/HeroImage/ImageBlock/ImageWrapper.jsx